import {Box, styled} from "@mui/material"
import React from "react"
import {useDroppable} from "@dnd-kit/core"

const DropAreaBox = styled(Box)(({ theme, isOver }) => ({
    position: "relative",
    boxSizing: "border-box",
    width: "100%",
    height: "400px",
    minHeight: "400px",
    maxHeight: "400px",
    overflow: "hidden",
    border: isOver ? "2px dashed #1976d2" : "2px solid #e0e0e0",
    borderRadius: "8px",
}))

const DropArea = ({ id, children }) => {
    const { setNodeRef, isOver } = useDroppable({ id })

    return (
        <DropAreaBox ref={setNodeRef} isOver={isOver}>
            {children}
        </DropAreaBox>
    )
}

export default DropArea